"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const R = __importStar(require("ramda"));
const PermissionsContext_1 = require("./PermissionsContext");
const isAllowed_1 = require("./isAllowed");
const IfAllowed = ({ children, permissions }) => {
    const context = react_1.useContext(PermissionsContext_1.PermissionsContext);
    let allowed = true;
    let result;
    result = permissions.map(([type, resource, permission]) => ({
        allowed: isAllowed_1.isAllowed({
            permission,
            resource,
            type,
        }, context.permissions),
        fields: R.pathOr({}, [type, resource, 'permission', permission, 'fields'], context.permissions),
    }));
    allowed = R.all(R.propEq('allowed', true), result);
    if (typeof children === 'function') {
        return children(allowed, result);
    }
    return allowed ? children : null;
};
exports.IfAllowed = IfAllowed;
//# sourceMappingURL=IfAllowed.js.map